import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import { Button, ContainerHeader, ErrorResponse } from '~components';
import { faFileLines } from '~components/icon';

import CompletedFormsList from './CompletedFormsList';
import ClientFormFillModal from './ClientFormFillModal';

const ClientFormsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  // The id arrives from the tp-v1 SSO-hop route (`/clients/:id/forms`); guard against a
  // missing/malformed segment so we never coerce it to NaN and feed that to the list/modal.
  const parsedId = Number(id);
  const clientId = Number.isInteger(parsedId) && parsedId > 0 ? parsedId : null;

  const [isFillModalOpen, setIsFillModalOpen] = useState(false);

  if (clientId === null) {
    return (
      <ErrorResponse
        message="Invalid client - no valid client id was provided in the URL."
        dataCy="client-forms-invalid-id"
      />
    );
  }

  return (
    <div className="p-2">
      <ContainerHeader icon={faFileLines} iconSize="1x" className="info" dataCy="client-forms-container-header">
        <span>Custom Forms</span>
      </ContainerHeader>

      <div className="nav d-flex justify-content-between bg-light p-2 mt-2 mb-2">
        <div className="d-flex align-items-center">
          <Button
            color="success"
            size="sm"
            className="ms-2"
            onClick={() => setIsFillModalOpen(true)}
            dataCy="client-forms-fill-btn"
          >
            Fill Form
          </Button>
        </div>
      </div>

      <CompletedFormsList clientId={clientId} />

      <ClientFormFillModal
        defaultClientId={clientId}
        isOpen={isFillModalOpen}
        onCancel={() => setIsFillModalOpen(false)}
      />
    </div>
  );
};

export default ClientFormsPage;
